import type {
  AllRegressionTests,
  RegressionTestBySetId,
} from "@/v2/entities/regression/Regression.model";

export function formatRegressionRunMethodLabel(
  runMethod:
    | AllRegressionTests["runMethod"]
    | RegressionTestBySetId["runMethod"]
    | undefined
): string {
  if (runMethod === "manual") return "Manual";
  if (runMethod === "auto") return "Automatic";
  if (runMethod === "aui") return "AUI";
  return "Test";
}
